export default __webpack_public_path__ + "static/media/Md_Shahbaz.5798ff30.pdf";